module.exports = __webpack_public_path__ + "img/engineersToolbox.495ef6fe.png";